import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTable } from 'react-table';
import { RootState } from "../../store/store";

export default function useAllUserAssignment() {
    const { Users } = useSelector((state: RootState) => state.UserAssignment);
    
    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'fullName',
        },
        {
            Header: 'Email',
            accessor: 'kionEmail',
        },
        {
            Header: 'Project',
            accessor: 'project',
        },
        {
            Header: 'Discipline',
            accessor: 'discipline',
        },
        {
            Header: 'Sequence',
            accessor: 'sequence',
        },
    ], []);

    return { ...useTable({ columns, data: Users }) };
}
